import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import { TaskAPI } from './API';
import { mapGrpcJobToJobDTO } from './jobGrpcDtoMapper';
var MilestoneStore = /*#__PURE__*/function (_Store) {
  function MilestoneStore() {
    var _this;
    _classCallCheck(this, MilestoneStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MilestoneStore, [].concat(args));
    _this.api = new TaskAPI({
      baseURL: env.JOB_API,
      getToken: _this.rootStore.authStore.getToken,
      supported_engine_version: env.SUPPORTED_ENGINE_VERSION
    });
    return _this;
  }
  _inherits(MilestoneStore, _Store);
  return _createClass(MilestoneStore, [{
    key: "complete",
    value: function complete(task) {
      var _this2 = this;
      return this.rootStore.api.jobsV3.completeTask(task.job.id, task.id).then(function () {
        return _this2.rootStore.api.jobsV3.getJob(task.job.id);
      }).then(mapGrpcJobToJobDTO).then(this.rootStore.jobStore.jobs.set);
    }
  }, {
    key: "uncomplete",
    value: function uncomplete(task) {
      var _this3 = this;
      return this.rootStore.api.jobsV3.uncompleteTask(task.job.id, task.id).then(function () {
        return _this3.rootStore.api.jobsV3.getJob(task.job.id);
      }).then(mapGrpcJobToJobDTO).then(this.rootStore.jobStore.jobs.set);
    }
  }]);
}(Store);
export { MilestoneStore as default };
//# sourceMappingURL=MilestoneStore.js.map
